import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "./login.slice";
import globalCatalogManagementSlice from "./globalCatalogManagement.slice";
import { all } from "redux-saga/effects";
import { sagaStore, watchStore } from "./sagaStore";
import allShopsSlice from "./allShops.slice";
import allShopProductSlice from "./allShopProducts.slice";
import allOrdersSlice from "./allOrders.slice";
import allCatDocSlice from "./allCatDoc.slice";
import allKycEntriesSlice from "./allKycEntries.slice";
import allShopOffersSlice from "./allShopOffers.slice";
import allOutgoingPaymentSlice from "./allShopPayouts.slice";
import shopAdminDashboardSlice from "./shopAdminDashboard.slice";
import allStoreEmployeeSlice from "./allStoreEmployee.slice";
import notificationsSlice from "./notifications.slice";
import billsSlice from "./bills.slice";
import uiSlice from "./ui.slice";
import customersSlice from "./customers.slice";
import allCatUpSlice from "./allCatUp.slice";
import categoriesAndSubcategoriesSlice from "./categoriesAndSubcategories.slice";
import shopOnboardingSlice from "./shopOnboarding.slice";
import subscriptionPlansSlice from "./subscriptionPlans.slice";
import shopSubscriptionSlice from "./shopSubscription.slice";
import pendingOrdersSlice from "./pendingOrders.slice";

const saga = createSagaMiddleware();
const store = configureStore({
  reducer: {
    login: loginSlice,
    globalCatalogManagement: globalCatalogManagementSlice,
    allShopManagement: allShopsSlice,
    allShopProductManagement: allShopProductSlice,
    allOrderManagement: allOrdersSlice,
    allCatDocManagement: allCatDocSlice,
    allShopKycManagement: allKycEntriesSlice,
    allShopOfferManagement: allShopOffersSlice,
    allOutgoingPaymentManagement: allOutgoingPaymentSlice,
    shopAdminDashboard: shopAdminDashboardSlice,
    allStoreEmployee: allStoreEmployeeSlice,
    notifications: notificationsSlice,
    billsManagement: billsSlice,
    ui: uiSlice,
    customers: customersSlice,
    allCatUpManagement: allCatUpSlice,
    categoriesAndSubcategories: categoriesAndSubcategoriesSlice,
    shopOnboarding: shopOnboardingSlice,
    subscriptionPlans: subscriptionPlansSlice,
    shopSubscription: shopSubscriptionSlice,
    pendingOrders: pendingOrdersSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(saga),
});

saga.run(function* watchAll() {
  yield all(sagaStore.list);
});

watchStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
